import React from 'react';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Auto Find Path Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> Automatically solve Vehicle Routing Problems (VRP) using optimization algorithms to find efficient routes for multiple vehicles serving all customers from a central depot.</p>
          
          <p><strong>Prerequisites:</strong></p>
          <ul>
            <li>At least 3 points set up in Setup Mode (1 depot + 2+ customers)</li>
            <li>Depot (start point) designated</li>
          </ul>

          <p><strong>Operation Steps:</strong></p>
          <ol>
            <li><strong>Review Configuration:</strong>
              <ul>
                <li>Verify all customer points are displayed</li>
                <li>Confirm depot is set (marked with S)</li>
                <li>Check vehicle capacity setting</li>
              </ul>
            </li>
            <li><strong>Set Vehicle Capacity:</strong>
              <ul>
                <li>Enter maximum capacity per vehicle</li>
                <li>Set to 0 for unlimited capacity</li>
                <li>Affects route distribution among vehicles</li>
              </ul>
            </li>
            <li><strong>Select Algorithm:</strong>
              <ul>
                <li>Choose from dropdown menu</li>
                <li>Options include Savings, Nearest Neighbor variants</li>
                <li>Different algorithms balance solution quality vs speed</li>
              </ul>
            </li>
            <li><strong>Click "Auto Solve":</strong>
              <ul>
                <li>System calculates optimal routes for all vehicles</li>
                <li>Each vehicle gets assigned customers</li>
                <li>Results display automatically</li>
              </ul>
            </li>
            <li><strong>Review Results:</strong>
              <ul>
                <li>Total distance across all vehicles</li>
                <li>Number of vehicles used</li>
                <li>Individual vehicle routes with color coding</li>
                <li>Each route shows sequence and distance</li>
              </ul>
            </li>
          </ol>

          <p><strong>Available Algorithms:</strong></p>
          <ul>
            <li><strong>Savings Algorithm:</strong>
              <ul>
                <li>Classic VRP heuristic</li>
                <li>Merges routes based on savings calculation</li>
                <li>Produces good quality solutions</li>
              </ul>
            </li>
            <li><strong>Nearest Neighbor:</strong>
              <ul>
                <li>Greedy construction heuristic</li>
                <li>Builds routes by selecting nearest customers</li>
                <li>Fast but may not be optimal</li>
              </ul>
            </li>
            <li><strong>Improvement Methods:</strong>
              <ul>
                <li>2-Opt, Swap, Move operations</li>
                <li>Refine initial solutions</li>
                <li>Reduce total distance</li>
              </ul>
            </li>
          </ul>

          <p><strong>Understanding Results:</strong></p>
          <ul>
            <li><strong>Total Distance:</strong> Sum of all vehicle routes in kilometers</li>
            <li><strong>Vehicle Count:</strong> Number of vehicles needed to serve all customers</li>
            <li><strong>Vehicle Routes:</strong> Each vehicle's customer sequence (Depot → C1 → C2 → ... → Depot)</li>
            <li><strong>Color Coding:</strong> Each vehicle route has unique color on map</li>
          </ul>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Need at least 3 points (1 depot + 2 customers)</li>
            <li>More vehicles can reduce total distance but increase operational costs</li>
            <li>Capacity constraints limit customers per vehicle</li>
            <li>Try different algorithms to find best solution</li>
            <li>Solution automatically saved for comparison</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 